import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export const EASE = [0.23, 1, 0.32, 1] as const;

/**
 * THE WAY IN.
 *
 * The flow used to open cold on a form field. Portal's own Build Your
 * Production opens on a held moment — one enormous line, one button — and
 * that half-second is most of why it reads as an occasion rather than a
 * task. Tom: *"it should be exciting and fun to put together."*
 *
 * **One line of copy, not three.** It had a paragraph of explanation and a
 * footnote of reassurance. Tom: *"we don't need all this writing — it is
 * obvious and all it does is clutter the screen."*
 *
 * In Jost, like everything else: *"No need to change the font."* What makes
 * this feel elsewhere is the scale, the motion and covering the screen.
 */
export function SetupStart({
  onStart,
  onClose
}: {
  onStart: () => void;
  onClose: () => void;
}) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.3,
    ease: EASE
  }} className="fixed inset-0 z-50 flex flex-col overflow-y-auto bg-ink text-paper pt-safe" data-id="element-1405" data-mp="qtnw4w1sy9z5">
      <div aria-hidden className="pointer-events-none absolute inset-0" style={{
      background: 'radial-gradient(120% 90% at 10% 0%, rgba(244,241,234,0.10) 0%, rgba(244,241,234,0.03) 40%, rgba(244,241,234,0) 70%)'
    }} data-id="element-1406" data-mp="2zrumq4998s64" />

      <div className="relative flex min-h-full flex-col px-6 py-7 sm:px-12 sm:py-9" data-id="element-1407" data-mp="3diptnb070z72">
        <div className="flex items-baseline justify-between gap-6" data-id="element-1408" data-mp="3ih12bier53np">
          <span className="label" data-id="element-1409" data-mp="33rv2bs83b9er">Portal Productions</span>
          <button type="button" onClick={onClose} className="label text-paper/45 transition-colors duration-150 hover:text-paper" data-id="element-1410" data-mp="33rbvp7nw47g1">
            Close
          </button>
        </div>

        <div className="flex flex-1 items-center py-16" data-id="element-1411" data-mp="9bine3h9bvk">
          <div className="max-w-4xl" data-id="element-1412" data-mp="52mszp7i0as8">
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease: EASE,
            delay: 0.05
          }} className="label m-0 text-mute" data-id="element-1413" data-mp="53plu2odsnas">
              A new client
            </motion.p>

            <motion.h1 initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease: EASE,
            delay: 0.11
          }} className="mt-6 m-0 font-display text-[3rem] font-extralight leading-[0.9] tracking-tight sm:text-[5rem] lg:text-[6.5rem]" data-id="element-1414" data-mp="5z9mh4n3ac7w">
              Build their page
            </motion.h1>

            <motion.div initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease: EASE,
            delay: 0.18
          }} className="mt-12" data-id="element-1415" data-mp="3ichczdcxdzi0">
              <button type="button" onClick={onStart} autoFocus className="label group inline-flex items-center gap-5 border border-paper bg-paper px-10 py-5 text-ink transition-colors duration-200 ease-out hover:bg-transparent hover:text-paper" data-id="element-1416" data-mp="34f2l81z79fmv">
                Start
                <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-200 ease-out group-hover:translate-x-1.5" strokeWidth={1.5} data-id="element-1417" data-mp="1tvft73nra9og" />
              </button>
            </motion.div>
          </div>
        </div>

        <div className="pb-safe" data-id="element-1418" data-mp="164k4ifeljulf" />
      </div>
    </motion.div>;
}